"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPersonWithLaptop = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M18.075 13c-.62-1.333-1.773-2-3.46-2H9.618c-1.688 0-2.842.667-3.463 2h11.92zM16 6a4 4 0 10-8 0 4 4 0 008 0z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4.041 16.4a2 2 0 011.96-2.4h12.04A2 2 0 0120 16.4l-.816 4a2 2 0 01-1.96 1.6H6.816a2 2 0 01-1.96-1.6l-.815-4zm8.963 1.602a1.002 1.002 0 11-2.003 0 1.002 1.002 0 012.003 0z' }))); };
exports.default = SvgPersonWithLaptop;
//# sourceMappingURL=PersonWithLaptop.js.map